import React from 'react';
import cn from 'classnames';
import { NavLink } from 'react-router-dom';

import { DefaultPropertyType } from '../../../../../interface';

import Styles from './index.module.scss';

type MenuType = 'navlink' | 'anchor';

type MenuItemPropsType = DefaultPropertyType & {
	icon?: React.ReactNode;
	nodeType?: MenuType;
	classNames?: Array<string> | string;
};

const MenuItem: React.FC<MenuItemPropsType> = ({
	label,
	value,
	icon,
	nodeType = 'navlink',
	classNames,
}) => {
	const getContent = (): React.ReactNode => {
		return (
			<>
				{icon}
				<span className={Styles.sidebarText}>{label}</span>
			</>
		);
	};

	const getNode = (): React.ReactNode => {
		if (nodeType === 'navlink') {
			return (
				<NavLink
					to={value as string}
					activeClassName="navbar__link--active"
					className={cn('nav-link1', classNames)}
				>
					{getContent()}
				</NavLink>
			);
		}
		return (
			<a className="nav-link1" href={value as string}>
				{getContent()}
			</a>
		);
	};

	return <li className="nav-item">{getNode()}</li>;
};

export default MenuItem;
